import React from 'react';

import { AddressFormContextProvider } from '../../../../../../../address/address-fields/context';
import { ReadOnlyCountryFields } from '../../../../../../../address/address-fields/read-only-country-fields';
import style from '../address.module.less';

/**
 * @typedef {object} RecipientInfoType
 * @property {string} name
 * @property {string} email
 * @property {string} phone
 */

/**
 * @param {object} props
 * @param {ShipToPropType} props.shipTo
 * @param {RecipientInfoType} props.recipientInfo
 * @returns {JSX.Element}
 */
export const ReadOnlyShipTo = ({ shipTo, recipientInfo }) => {
  return (
    <AddressFormContextProvider address={shipTo} recipientInfo={recipientInfo}>
      <ReadOnlyCountryFields style={style['read-only-address']} />
    </AddressFormContextProvider>
  );
};
